import styled from 'styled-components'

import { style } from 'theme'

export const FormRow = styled.div`
  padding-top: 20px;
`

export const StyledHeroHeader = styled.div`
  font-size: 22px;
  line-height 30px;
  margin: 30px auto 10px;
  text-align: center;
  max-width: 340px;
`

export const StyledHeroSubtext = styled.div`
  font-size: 14px;
  line-height: 22px;
  p {
    display: inline;
    margin: 0;
  }
`

export const StyledHeroDescription = styled.div`
  max-width: 340px;
  width: 100%;
  margin: 0 auto 10px;
  text-align: center;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    max-width: unset;
    margin-bottom: 10px;
  }
`

export const FooterText = styled.div`
  font-weight: 400;
  font-size: 12px;
  color: ${style(theme => theme.colors.stone)};
  text-align: left;
  max-width: 340px;
  width: 100%;
  margin: 0 auto;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    max-width: unset;
  }
`

export const ImageContainer = styled.div`
  margin: 58px auto 0px auto;
  display: flex;
  justify-content: center;
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin: 74px auto 0px auto;
  }
`
